import {CharacterInfo} from "../assets/constants/characterInfo";

const STORAGE_KEY = "character";

export const getCharacterFromStorage = (): CharacterInfo | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }
    return JSON.parse(stored) as CharacterInfo;
  } catch {
    return null;
  }
};

export const saveCharacterToStorage = (character: CharacterInfo): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(character));
};
